import { action, observable } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { App, AppManager, Input } from 'core/index';
import { FormStore } from 'libs/forms/app';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';

import { ModeratorFormMutation } from 'apps/channel/gql';
import { conf } from 'apps/channel/config.yaml';

export class ModeratorFormApp extends App {
  static registryName = 'ModeratorFormApp';
  @observable message = '';
  @observable evidence = '';
  init() {
    this.form = new FormStore(this, conf, 'moderatorForm');
  }

  @action Post = () => {
    if (this.form.isValid) {
      this.form.SetPosting(true);
      clientStore.SetPosting(true);
      this.manager.Post({
        onSysErr: this.onError,
        onUserErr: this.onError,
        onSuccess: this.onSuccess,
      });
    } else {
      this.form.alert();
    }
  };

  @action onSuccess = () => {
    this.form.SetPosting(false);
    this.form.clearDraft();
    clientStore.SetPosting(false);
    modalStore.ClearComponent();
    Alert.success(i18next.t("Thanks for your application! We'll be in touch."));
  };

  @action onError = () => {
    this.form.SetPosting(false);
    clientStore.SetPosting(false);
    Alert.error(
      i18next.t(
        'Hmm... We failed to submit your Application. Please try again.',
      ),
    );
  };
}

export class ModeratorFormAppManager extends AppManager {
  static registryName = 'ModeratorFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.moderatorFormApp = new ModeratorFormApp(this, {});
    this.moderatorFormApp.init();
    this.moderatorFormInput = new Input({
      spaceId: () => this.channelId,
      groupName: () => 'moderator',
      info: () =>
        JSON.stringify({
          message: this.moderatorFormApp.message,
          evidence: this.moderatorFormApp.evidence,
        }),
    });
  }

  @action Post = options => {
    this.mutations.push(
      ModeratorFormMutation.New(this.moderatorFormInput, options),
    );
  };
}
